"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _path = _interopRequireDefault(require("../helpers/path"));
var _redirectIfAuthorizedHelper = require("../helpers/redirectIfAuthorizedHelper");
var _config = _interopRequireDefault(require("../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function redirectIfAuthorized(WrappedComponent) {
  var ModifiedComponent = function ModifiedComponent(props) {
    var shouldRedirect = props.shouldRedirect,
      redirectLocation = props.redirectLocation,
      isAuthenticated = props.isAuthenticated;
    if (isAuthenticated) {
      if ((0, _redirectIfAuthorizedHelper.redirectExceptions)()) {
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, props);
      }
      if (shouldRedirect) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
          to: {
            pathname: redirectLocation.pathname,
            search: redirectLocation.search
          }
        });
      } else {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
          to: (0, _path["default"])("".concat(_config["default"].Navigation.landingPage, "?default=redirect"))
        });
      }
    }
    return /*#__PURE__*/_react["default"].createElement(WrappedComponent, props);
  };
  var mapStateToProps = function mapStateToProps(state) {
    return {
      isAuthenticated: state.auth.isAuthenticated,
      shouldRedirect: state.auth.shouldRedirect,
      redirectLocation: state.auth.location
    };
  };
  return (0, _reactRedux.connect)(mapStateToProps, null)(ModifiedComponent);
}
var _default = exports["default"] = redirectIfAuthorized;